
import React from 'react';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Header from './header/header';
import { PRIMARY_COLOR, LIGHT_MODE } from '../utils/constants';
import useThemeQuery from '../graphql/queries/toggle-theme';

const App = props => {
    const { children, location, router } = props;
    const { data } = useThemeQuery();

    return (
            <Box bgcolor={data && data.theme ? PRIMARY_COLOR: LIGHT_MODE} p={2}>
                <CssBaseline />
                <Header router={router} location={location}/>
                {/* { location.pathname !== '/profile' && <Header router={router} location={location}/>} */}
                <Box px={10} py={3}>
                    {children}
                </Box>
            </Box>
    )
}

export default App;